<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16922360457393588729382104743.png",
                ja: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169209998067904897363670123167.jpg",
                "zh-cn": "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1691425508583978968482705961.png",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicCombat.vue